<script lang="ts">
  import { auth } from '$lib/stores/auth';
  let email = '';
  let password = '';
  let mode: 'signin' | 'forgot' = 'signin';
  let resetSent = false;

  async function sendReset() {
    const ok = await auth.requestPasswordReset(email);
    if (ok) resetSent = true;
  }
</script>

<div class="auth-container">
  {#if $auth.loading}
    <p>Loading authentication...</p>
  {:else if $auth.user}
    <div class="user-info">
      <p>Welcome, {$auth.user.email}</p>
      <button on:click={() => auth.signOut()}>Sign Out</button>
    </div>
  {:else}
    <div class="auth-buttons">
      {#if $auth.error}
        <p class="error">{$auth.error}</p>
      {/if}

      {#if mode === 'forgot'}
        <h2>Reset password</h2>
        {#if resetSent}
          <p class="info">If an account exists for that email, you'll receive a reset link shortly.</p>
        {:else}
          <div class="email-login">
            <input type="email" bind:value={email} placeholder="Email" />
            <button on:click={sendReset} disabled={$auth.loading}>Send reset link</button>
          </div>
        {/if}
        <button class="link" on:click={() => { mode = 'signin'; resetSent = false; }}>
          &larr; Back to sign in
        </button>
      {:else}
        <h2>Sign In</h2>
        <div class="email-login">
          <input type="email" bind:value={email} placeholder="Email" />
          <input type="password" bind:value={password} placeholder="Password" />
          <button on:click={() => auth.signInWithEmail(email, password)}>Sign in with Email</button>
          <button on:click={() => auth.signUpWithEmail(email, password)}>Sign up with Email</button>
        </div>
        <button class="link" on:click={() => { mode = 'forgot'; }}>Forgot password?</button>
        <p class="info">Email/password sign-in is enabled. Google and Apple are hidden for now.</p>
      {/if}
    </div>
  {/if}
</div>

<style>
  .auth-container {
    max-width: 400px;
    margin: 2rem auto;
    padding: 2rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    text-align: center;
  }

  .auth-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .email-login {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  input {
    padding: 0.75rem 1rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
  }

  button {
    padding: 0.75rem 1rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    font-size: 1rem;
    transition: all 0.2s;
  }

  button:hover {
    background: #f5f5f5;
    border-color: #999;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .error {
    color: #d32f2f;
    margin-bottom: 1rem;
  }

  .link {
    background: none;
    border: none;
    color: #1565c0;
    cursor: pointer;
    font-size: 0.9rem;
    padding: 0;
    text-decoration: underline;
  }

  .link:hover {
    background: none;
    color: #0d47a1;
  }

  hr {
    border: none;
    border-top: 1px solid #eee;
    margin: 1rem 0;
  }
</style>
